export enum SortBy {
  ALPHA = 'alpha',
  RSVP = 'rsvp',
  COMMENTS = 'comments',
  DELIVERY_STATUS = 'deliveryStatus',
}

export type SortDirection = 'asc' | 'desc';
